export default {
    init() {
        //Ppc popup start
        // eslint-disable-next-line no-unused-vars
        let currentPplVendorSlugs = [];
        if (window.topThreePplVendorSlugs !== undefined) {
            //eslint-disable-next-line no-undef
            currentPplVendorSlugs = JSON.parse(topThreePplVendorSlugs)
        }
        $('.ppl-popup .popup-item-close, .ppl-popup .ppc-popup-no-thanks').on('click', function () {
            removedCheckedItemsForCompare();
            resetPpcPopUp($(this));
        });
    function resetPpcPopUp(currentButton)
    {
        currentButton.parents('.ppl-popup').addClass('hidden');
        // eslint-disable-next-line no-undef,no-unused-vars
        if (window.topThreePplVendorSlugs !== undefined) {
            //eslint-disable-next-line no-undef
            currentPplVendorSlugs = JSON.parse(topThreePplVendorSlugs);
        }
            generatePpcPopupItems();
            generateRequestFormFunction();
    }

    function generatePpcPopupItems()
    {
      // eslint-disable-next-line no-unused-vars,no-undef
        let parsedTopThreePplVendor = JSON.parse(topThreePplVendor);
        $('.popup-items-container').html('');
      // eslint-disable-next-line no-undef
        if (parsedTopThreePplVendor.length > 0) {
            parsedTopThreePplVendor.forEach(function ($vendor) {
                let popupItems = '<div class="ppc-popup-item d-flex justify-content-center align-items-center">\n' +
                '                    <div onClick="removePpcItem(this)" class="ppc-item-close position-absolute text-red font-size-9">\n' +
                '                      <i class="fal fa-times-circle fa-2x"></i>\n' +
                '                    </div>\n' +
                '                    <img class="mx-auto" src="https://d36w3vgtkvgnsp.cloudfront.net/' + $vendor['logo'] + '" alt="' + $vendor['name'] + '"/>\n' +
                '                  </div>';

                $('.popup-items-container').append(popupItems);
            });
        }
    }

        window.removePpcItem = function (close) {
            let pplItems = $('.popup-items-container > .ppc-popup-item');
            let index = pplItems.index($(this).parent());
            $(close).parent().remove();
            currentPplVendorSlugs.splice(index, 1);
            if (currentPplVendorSlugs.length === 0) {
                $('.ppl-popup').addClass('hidden');
                enablePopUpScroll();
                removedCheckedItemsForCompare();
              // eslint-disable-next-line no-unused-vars
                if (window.topThreePplVendorSlugs !== undefined) {
                  // eslint-disable-next-line no-undef
                    currentPplVendorSlugs = JSON.parse(topThreePplVendorSlugs);
                }
                generatePpcPopupItems();
            }
            generateRequestFormFunction();
        }

        window.sendPplRequest = function (button, vendors = [], product = '') {
            $('body').addClass('disable-scroll');

            $.ajax({
                url: window.ajax.url,
                type: 'get',
                dataType: 'json',
                data: {
                    action: 'hub_spot_form',
                    vendors: vendors,
                    product: product,
                    vendorPage: true,
                    showMessage: true,
                },
                success: function (result) {
                    $('.popup-request-form').text('').append(result.data.form);
                    enablePopUpScroll;
                },
                error: function () {
                    enablePopUpScroll();
                },
            });

            resetPpcPopUp($(button));
        }

        function generateRequestFormFunction()
        {
            let slug = [];

            //eslint-disable-next-line no-undef, no-unused-vars
            currentPplVendorSlugs.slice(0, 3).forEach(function (item) {
                let newSlug = {
                    slug: item,
                }

                slug.push(newSlug)
            });

            //eslint-disable-next-line no-undef, no-unused-vars
            let productSlug = $('#product-slug').val();
            let functionAttr = 'sendPplRequest(this, ' + JSON.stringify(slug) + ', \'' + productSlug + '\')';

            $('.send-ppl-request').attr('onclick', functionAttr);
        }

        function removedCheckedItemsForCompare()
        {
            $('.compare-button.checked').each(function () {
                $(this).removeClass('checked');
            });
        }

        function enablePopUpScroll()
        {
            $('body').removeClass('disable-scroll');
            window.scrollTo(0, $('body').css('top').replace('-', '').replace('px',''));
            $('body').removeAttr('style');
        }

      //Ppc popup end
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
};
